import portfolioService from '@/services/portfolioService'

export default {
  ...portfolioService,
}



// WEBPACK FOOTER //
// ./src/-client-app/services/portfolioService.js